import React, { useState } from 'react';
import { ArrowLeft, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Gallery = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('alle');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = [
    { id: 'alle', label: 'Alle Projekte' },
    { id: 'dachdeckerarbeiten', label: 'Dachdeckerarbeiten' },
    { id: 'zimmererarbeiten', label: 'Zimmererarbeiten' },
    { id: 'abbrucharbeiten', label: 'Abbrucharbeiten' }
  ];

  const galleryImages = [
    {
      id: 1,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/9jioncfd_WhatsApp%20Image%202025-11-29%20at%2020.57.33.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Professionelle Dacheindeckung'
    },
    {
      id: 16,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/2rxs3equ_WhatsApp%20Image%202025-11-29%20at%2020.57.56.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dachsanierung'
    },
    {
      id: 17,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/i5xg9uxn_WhatsApp%20Image%202025-11-29%20at%2020.57.57.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dacheindeckung'
    },
    {
      id: 18,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/9z6crrqi_WhatsApp%20Image%202025-11-29%20at%2020.58.12.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dachreparatur'
    },
    {
      id: 19,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/pqc4izi3_WhatsApp%20Image%202025-11-29%20at%2021.01.51.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dach-Projekt'
    },
    {
      id: 20,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/2ypsa2v1_WhatsApp%20Image%202025-11-29%20at%2021.01.52.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dacharbeiten'
    },
    {
      id: 21,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/u277x0x0_WhatsApp%20Image%202025-11-29%20at%2020.57.25.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dachneueindeckung'
    },
    {
      id: 22,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/r4ft9gv6_WhatsApp%20Image%202025-11-29%20at%2020.57.33.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dachsanierung'
    },
    {
      id: 23,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/1vkhe4gb_WhatsApp%20Image%202025-11-29%20at%2020.57.38.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dacheindeckung'
    },
    {
      id: 24,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/kq56yjja_WhatsApp%20Image%202025-11-29%20at%2020.57.40.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dachreparatur'
    },
    {
      id: 25,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/uo2pl6gj_WhatsApp%20Image%202025-11-29%20at%2020.57.44.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Dach-Projekt'
    },
    {
      id: 26,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/ryg2w2uk_WhatsApp%20Image%202025-11-2%20at%2020.57.25.jpeg',
      category: 'dachdeckerarbeiten',
      title: 'Dachdeckerarbeiten',
      description: 'Professionelle Dacharbeiten'
    },
    {
      id: 2,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/tuyvvww4_WhatsApp%20Image%202025-11-29%20at%2021.11.55%20%281%29.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Professioneller Rückbau'
    },
    {
      id: 3,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/7hysv5ry_WhatsApp%20Image%202025-11-29%20at%2020.57.22%20%281%29.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Hochwertige Holzkonstruktionen'
    },
    {
      id: 4,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/xn66za8c_WhatsApp%20Image%202025-11-29%20at%2021.12.05.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Dachstuhlbau'
    },
    {
      id: 5,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/yz3x60uk_WhatsApp%20Image%202025-11-29%20at%2021.12.16.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Kompletter Gebäudeabbruch'
    },
    {
      id: 27,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/3dqsobzn_WhatsApp%20age%202025-11-29%20at%2021.14.31.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Professioneller Rückbau'
    },
    {
      id: 28,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/ygfvrwl4_WhatsApp%20Image%202025-1-29%20at%2021.14.28.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Abbruch-Projekt'
    },
    {
      id: 29,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/1j3md0qz_WhatsApp%20Image%202025-11-29%20at%2021.12.18.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Gebäudeabbruch'
    },
    {
      id: 30,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/2yg6p9ot_WhatsApp%20Image%202025-11-29%20at%2021.14.27.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Abbrucharbeiten'
    },
    {
      id: 31,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/kcuctjkk_WhatsApp%20Image%202025-11-29%20at%2021.14.28.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Professioneller Abbruch'
    },
    {
      id: 32,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/u349kmjy_WhatsApp%20Image%202025-11-29%20at%2021.14.30.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Rückbau-Projekt'
    },
    {
      id: 33,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/7enqexy9_WhatsApp%20Image%202025-11-29%20at%2021.14.31.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Gebäudeabbruch'
    },
    {
      id: 34,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/rwvih5yb_WhatsApp%20Image%202025-11-29%20at%2021.14.41.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Abbruch-Arbeiten'
    },
    {
      id: 35,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/c50jaeb9_WhatsApp%20Image%202025-11-29%20at%2021.14.43.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Kompletter Rückbau'
    },
    {
      id: 36,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/fh7ma0ku_WhatsApp%20Image%202025-11-29%20at%2021.12.17.jpeg',
      category: 'abbrucharbeiten',
      title: 'Abbrucharbeiten',
      description: 'Abbrucharbeiten'
    },
    {
      id: 6,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/utzx09u5_WhatsApp%20Image%202025-11-29%20at%2020.57.29.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Holzkonstruktionen'
    },
    {
      id: 7,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/759baxo5_WhatsApp%20Image%202025-11-29%20at%2020.57.30.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Zimmerei-Projekt'
    },
    {
      id: 8,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/v2yorlqs_WhatsApp%20Image%202025-11-29%20at%2020.57.34.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Holzbauarbeiten'
    },
    {
      id: 9,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/oz3sakan_WhatsApp%20Image%202025-11-29%20at%2020.58.15.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Dachkonstruktion'
    },
    {
      id: 10,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/4hljvlal_WhatsApp%20Image%202025-11-29%20at%2020.58.17.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Zimmerei-Arbeiten'
    },
    {
      id: 11,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/k240ijzm_WhatsApp%20Image%202025-11-29%20at%2020.58.18.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Holzbau-Projekt'
    },
    {
      id: 12,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/mge8kuvu_WhatsApp%20Image%202025-11-29%20at%2021.12.02.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Dachstuhl-Konstruktion'
    },
    {
      id: 13,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/etrzojff_WhatsApp%20Image%202025-11-29%20at%2021.12.03.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Holzkonstruktion'
    },
    {
      id: 14,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/cnxji1bo_WhatsApp%20Image%202025-11-29%20at%2021.12.07.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Zimmerei-Arbeiten'
    },
    {
      id: 15,
      src: 'https://customer-assets.emergentagent.com/job_roofdemo/artifacts/hi6dzahv_WhatsApp%20Image%202025-11-29%20at%2021.12.09.jpeg',
      category: 'zimmererarbeiten',
      title: 'Zimmererarbeiten',
      description: 'Holzbau'
    }
  ];

  // Shuffle function to randomize images
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const filteredImages = activeCategory === 'alle' 
    ? shuffleArray(galleryImages)
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-950 pt-20">
      {/* Header */}
      <div className="bg-gray-900 border-b border-yellow-500/20 py-8">
        <div className="container mx-auto px-4">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center space-x-2 text-gray-400 hover:text-yellow-400 transition-colors duration-200 mb-6"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Zurück zur Startseite</span>
          </button>
          
          <div className="text-center">
            <span className="inline-block text-yellow-500 font-semibold text-sm uppercase tracking-wider mb-3">
              Galerie
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-red-500 mb-6">
              Unsere Projekte
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
              Entdecken Sie unsere erfolgreich abgeschlossenen Projekte in den Bereichen Dachdeckerei, Zimmerei und Abbruch.
            </p>
          </div>
        </div>
      </div>

      {/* Category Tabs */}
      <div className="bg-gray-900/50 backdrop-blur-sm border-b border-yellow-500/20">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4 py-6">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                  activeCategory === cat.id
                    ? 'bg-gradient-to-r from-yellow-500 to-red-600 text-white shadow-lg scale-105'
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-white border border-yellow-500/20'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              className="group relative bg-gray-900 rounded-2xl overflow-hidden cursor-pointer border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300 hover:scale-105"
              onClick={() => setSelectedImage(image)}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{image.title}</h3>
                  <p className="text-gray-300">{image.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredImages.length === 0 && (
          <div className="text-center py-20">
            <p className="text-gray-400 text-xl">Keine Bilder in dieser Kategorie verfügbar.</p>
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 bg-gray-800 rounded-full p-3 hover:bg-gray-700 transition-colors duration-200 shadow-lg z-50"
          >
            <X className="w-6 h-6 text-white" />
          </button>

          <div
            className="max-w-6xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-2xl shadow-2xl"
            />
            <div className="mt-6 text-center">
              <h3 className="text-2xl font-bold text-white mb-2">{selectedImage.title}</h3>
              <p className="text-xl text-gray-300">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
